module.exports = __webpack_public_path__ + "img/level-1.2b1f2257.svg";